import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { motion } from "framer-motion";
import Layout from "./Layout";

import wireless from "../../assests/wireless.jpg";
import dd from "../../assests/dd.jpg";
import cctv2 from "../../assests/cctv2.jpg";
import rackrack from "../../assests/rackrack.jpg";
import rackss from "../../assests/rackss.png";
import it from "../../assests/it.jpg";
import fibers from "../../assests/fibers.jpg";
import whatis from "../../assests/whatis.jpg";
import tele from "../../assests/tele.jpg";

const FirstSlider = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  // Component wrapper for each section (except slider)
  const SectionContainer = ({ children }) => (
    <div className="bg-white/5 backdrop-blur-md rounded-2xl shadow-lg p-10 my-16 w-[90%] mx-auto">
      {children}
    </div>
  );

  return (
    <Layout>
      {/* Hero Slider (excluded from container) */}
      <section className="w-[90%] mx-auto">
        <Slider {...sliderSettings}>
          <div className="relative">
            <img
              src={wireless}
              className="w-full h-[500px] object-cover rounded-2xl shadow-lg"
              alt="Network"
            />
            <div className="absolute bottom-8 left-8 bg-black/50 text-white p-4 rounded-xl max-w-[60%]">
              <h2 className="text-2xl font-bold">Networks Solutions</h2>
              <p className="text-sm mt-2">
                LAN, WAN & Wireless Solutions designed with top industry
                partners and expert support teams.
              </p>
            </div>
          </div>

          <div className="relative">
            <img
              src={dd}
              className="w-full h-[500px] object-cover rounded-2xl shadow-lg"
              alt="Data Center"
            />
            <div className="absolute bottom-8 left-8 bg-black/50 text-white p-4 rounded-xl max-w-[60%]">
              <h2 className="text-2xl font-bold">Data Center & Storage</h2>
              <p className="text-sm mt-2">
                Backup, replication, archiving, and migration solutions to
                secure your business data.
              </p>
            </div>
          </div>

          <div className="relative">
            <img
              src={cctv2}
              className="w-full h-[500px] object-cover rounded-2xl shadow-lg"
              alt="Security"
            />
            <div className="absolute bottom-8 left-8 bg-black/50 text-white p-4 rounded-xl max-w-[60%]">
              <h2 className="text-2xl font-bold">Security & CCTV Solutions</h2>
              <p className="text-sm mt-2">
                Cutting-edge surveillance systems to protect your business and
                assets.
              </p>
            </div>
          </div>
        </Slider>
      </section>

      {/* Intro Section */}
      {/* <SectionContainer>
        <motion.section
          className="relative text-left px-6 max-w-5xl mx-auto"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <p className="text-3xl md:text-4xl text-[#201C59] leading-relaxed font-semibold">
            Through our trusted industry-leading partners, we provide the most
            suitable LAN and WAN solutions tailored to your organization’s
            needs. Our technical and support teams will guide you every step of
            the way—from network design and installation to post-deployment
            support.
          </p>
        </motion.section>
      </SectionContainer> */}

      {/* Infrastructure Section */}
      <SectionContainer>
        <motion.section
          className="text-center px-6"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <h2 className="text-3xl font-bold text-[#201C59] mb-6">
            Infrastructure & Solutions Division
          </h2>
          <p className="text-[#201C59] max-w-4xl mx-auto leading-relaxed">
            An exclusive division offering turnkey corporate Electric solutions:
            VOIP, IPTV, Fire Alarm, Access Control, CCTV, and Public Address
            Systems. Our engineers deliver optimized solutions with the best
            performance and price.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-10 mb-4">
            <img
              src={rackrack}
              className="rounded-xl shadow-lg h-40 w-full object-cover"
              alt="rack"
            />
            <img
              src={it}
              className="rounded-xl shadow-lg h-40 w-full object-cover"
              alt="it"
            />
            <img
              src={rackss}
              className="rounded-xl shadow-lg h-40 w-full object-cover"
              alt="rack2"
            />
            <img
              src={fibers}
              className="rounded-xl shadow-lg h-40 w-full object-cover"
              alt="fiber"
            />
          </div>
        </motion.section>
      </SectionContainer>

      {/* Digital Solutions Section */}
      <SectionContainer>
        <motion.section
          className="text-center px-6"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <h2 className="text-3xl font-bold text-[#201C59] mb-6">
            Digital Solutions for Your Business
          </h2>
          <p className="text-[#201C59] max-w-3xl mx-auto leading-relaxed">
            We help organizations design and install NEC digital signage
            tailored to their unique marketing goals, target audience, and
            environments.
          </p>
          <img
            src={whatis}
            className="mx-auto rounded-xl shadow-lg mt-8"
            alt="Digital"
          />
        </motion.section>
      </SectionContainer>

      {/* Telecom Section */}
      <SectionContainer>
        <motion.section
          className="text-center px-6"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <h2 className="text-3xl font-bold text-[#201C59] mb-6 ">
            Telecom Survey & Implementation
          </h2>
          <p className="text-[#201C59] max-w-3xl mx-auto leading-relaxed">
            DTEC is an approved contractor for Telecom projects across the
            country, with expertise in Fixed Access Network installations and
            upgrades.
          </p>
          <img
            src={tele}
            className="mx-auto rounded-xl shadow-lg mt-8"
            alt="Telecom"
          />
        </motion.section>
      </SectionContainer>

      <div className="w-full bg-blue-600 h-3 mt-10"></div>
    </Layout>
  );
};

export default FirstSlider;
